const products = [
  {
    id: 'vpn',
    name: 'DUGAN VPN',
    tag: 'Privacy & Security',
    description:
      'A powerful VPN application engineered for iOS, offering military-grade encryption, zero-log policy, and lightning-fast servers across the globe to keep your data private.',
    highlights: ['256-bit AES Encryption', 'Zero-Log Policy', '60+ Server Locations', 'Kill Switch'],
    image:
      'https://public.readdy.ai/ai/img_res/51be687bb08d7d2d21a5ee0281f5426c.jpg',
    accent: '#16A34A',
    accentLight: '#F0FDF4',
    icon: 'ri-shield-keyhole-line',
  },
  {
    id: 'cleaner',
    name: 'DUGAN Cleaner',
    tag: 'Performance & Storage',
    description:
      'An intelligent iOS cleaner that frees up storage, removes junk files, and optimizes your device performance — keeping your iPhone running like new every single day.',
    highlights: ['Smart Junk Removal', 'Photo Deduplication', 'Storage Insights', 'Background Clean'],
    image:
      'https://readdy.ai/api/search-image?query=modern%20iOS%20phone%20cleaner%20optimization%20app%20interface%20on%20iPhone%20screen%2C%20clean%20white%20and%20light%20gray%20UI%20design%2C%20storage%20percentage%20ring%20chart%2C%20sparkle%20effect%2C%20minimalist%20aesthetic%2C%20premium%20product%20mockup%20photography%2C%20bright%20warm%20studio%20lighting%2C%20professional%20product%20visualization%2C%20no%20text%20overlay&width=500&height=600&seq=cleaner001&orientation=portrait',
    accent: '#D97706',
    accentLight: '#FFFBEB',
    icon: 'ri-sparkling-line',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <p className="text-amber-500 text-xs font-semibold uppercase tracking-[0.3em] mb-3">
              / Our Products
            </p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              Designed for<br />Excellence
            </h2>
          </div>
          <p className="text-gray-400 text-base max-w-sm leading-relaxed">
            Each application is crafted with precision and care, built to enhance the everyday
            iOS experience for users worldwide.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group rounded-2xl overflow-hidden bg-[#FAF9F6] hover:bg-white transition-all duration-300"
              style={{ border: '1px solid #F0EDE8' }}
            >
              {/* Image */}
              <div className="relative h-[300px] md:h-[360px] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                {/* Tag */}
                <div className="absolute top-5 left-5">
                  <span
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold"
                    style={{ backgroundColor: product.accentLight, color: product.accent }}
                  >
                    <i className={`${product.icon} text-sm`}></i>
                    {product.tag}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-7 md:p-8">
                <h3 className="text-2xl font-extrabold text-gray-900 mb-3">{product.name}</h3>
                <p className="text-gray-500 text-base leading-relaxed mb-6">{product.description}</p>

                {/* Highlights */}
                <div className="grid grid-cols-2 gap-3">
                  {product.highlights.map((h) => (
                    <div key={h} className="flex items-center gap-2 text-sm text-gray-600">
                      <span
                        className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0"
                        style={{ backgroundColor: product.accentLight }}
                      >
                        <i className="ri-check-line text-xs" style={{ color: product.accent }}></i>
                      </span>
                      {h}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
